export default function (state, val) {
    state.list = val.Items;
}